import * as React from 'react';
import { connect } from 'react-redux';

import CalendarContainerView from '../views/buy-tickets-container.view';
import { IBuyTicketsAppState } from '../redux-state';
import { IShowPosterInfo } from '../classes/showPosterInfo';

interface IBuyTicketsContainerExternalProps {

}

interface StateToProps {
    isLoading: boolean;
    showPosterInfo: IShowPosterInfo;
}

export type CalendarContainerProps = IBuyTicketsContainerExternalProps & StateToProps;

export class CalendarContainerBase extends React.Component<CalendarContainerProps, any> {
    componentDidMount() {
        if (this.props.isLoading) {
            this.showLoader();
        }
    }
    componentDidUpdate(prevProps: CalendarContainerProps) {
        if (this.props.isLoading) {
            this.showLoader();
        }
        else {
            this.removeLoader();
        }
    }
    removeLoader() {
        const superParent = document.documentElement;
        superParent.removeAttribute("data-calendar-loading");
    }

    showLoader() {
        const superParent = document.documentElement;
        // attribute removal happens in the views of the components that trigger loading states.
        // removal should happen after all other callback functionality.
        superParent.setAttribute("data-calendar-loading", "true");
    }

    render() {
        return (
            <CalendarContainerView {...this.props} />
        )
    }
}

function mapStateToProps(state: IBuyTicketsAppState, ownProps: IBuyTicketsContainerExternalProps): StateToProps {
    return {
        isLoading: state.calendar.updating,
        showPosterInfo: state.calendar.showPosterInfo
    }
}

export default connect<StateToProps>(mapStateToProps)(CalendarContainerBase);